import React, { useRef, useState, useEffect } from "react";
import Highlighter from "react-highlight-words";
import { SearchOutlined, UserOutlined, DeleteOutlined, FilterFilled, PlusOutlined, PlusCircleFilled, FilterOutlined } from "@ant-design/icons";
import { Table, Input, Image, Typography, Button, Form, Space, Popconfirm, Modal, List, Avatar, Select, message, Card, Tag, Row, Col, Spin } from "antd";
import { bugReportHandle } from "../state/actions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Loading } from "../../Common/components/Loading";
import { EmptyData } from "../../Common/components/EmptyData";
import { generateFullNameFromObj, generateInitialsFromObj } from "../../Common/utils/universalFuntions";
import { roleAccessFunc } from "../../Common/commondata/commonData";
import { FilterDisplay } from "../../Common/components/FilterDisplay";
import { EditOutlined } from "@ant-design/icons";
import { offerTableHandle } from "../../OfferTable/state/actions";

const capitalizeFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const text = "Are you sure to delete this task?";
const { Text } = Typography;

const BUGTable = ({ list }) => {
  const { totalRecords, bugLlistingData, bugLlistLoading } = useSelector((state) => state.bugReport);
  const { roleAccessed } = useSelector((state) => state.account, shallowEqual);
  const dispatch = useDispatch();

  const [searchText, setsearchText] = useState("");
  const [searchedColumn, setsearchedColumn] = useState("");
  const [filterbystatus, setFilterbystatus] = useState("");
  const [disableBtn, setdisableBtn] = useState(true);
  const [form] = Form.useForm();
  const searchInput = useRef();
  const searchRef = useRef();

  // Assignment Modal States

  const [showDevModal, setShowDevModal] = useState(false);
  const [showAssigneeModal, setShowAssigneeModal] = useState(false);
  const [assignedDevsMap, setAssignedDevsMap] = useState({});
  const [customDev, setCustomDev] = useState("");
  const [selectedBugId, setSelectedBugId] = useState(null);
  // Sprint Modal States
  const [showSprintModal, setShowSprintModal] = useState(false);
  const [selectedSprint, setSelectedSprint] = useState({});
  const [customSprint, setCustomSprint] = useState("");
  // const [filterBySprint, setFilterBySprint] = useState([]);

  // Work Type Modal States
  const [showWorkTypeModal, setShowWorkTypeModal] = useState(false);
  const [assignedWorkTypesMap, setAssignedWorkTypesMap] = useState({});
  const [customWorkType, setCustomWorkType] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [filterBydevelopers, setFilterBydevelopers] = useState([]);
  const [filterByworkType, setFilterByworkType] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
  const [currentQuery, setCurrentQuery] = useState({});

  const handleGlobalSearch = () => {
    setsearchText(globalSearch);
  };

  // Work Type list based on your image
  const [workTypesList, setWorkTypesList] = useState([
    { id: "1", name: "BUG" },
    { id: "2", name: "TASK" },
    { id: "3", name: "EPIC" },
    { id: "4", name: "STORY" },
    { id: "5", name: "RULES" },
  ]);

  // Sprint list
  const [sprintList, setSprintList] = useState([]);

  // Use state to manage the dynamic list of developers
  const [devsList, setDevsList] = useState([]);

  const inputRef = useRef();
  // Work Type Modal functions
  const displayWorkTypeModal = (record) => {
    setSelectedBugId(record.idTitleSearch._id);
    setSelectedWorkType(record.assignedWorkType || null);
    setShowWorkTypeModal(true);
  };

  const handleWorkTypeCancel = () => {
    setShowWorkTypeModal(false);
    setSelectedBugId(null);
  };

  const handleWorkTypeOk = () => {
    if (!selectedWorkType) {
      message.error("Please select a work type!");
      return;
    }
    dispatch(bugReportHandle.updateBugWorkType(selectedBugId, selectedWorkType));
    setShowWorkTypeModal(false);
    setSelectedBugId(null);
    setSelectedWorkType(null);
  };
  const handleWorkTypeSelection = (workTypeName) => {
    setSelectedWorkType(workTypeName);
  };
  

  // Modal functions for Assignment
  let accessToken = localStorage.getItem("auth");
  const developersFromStore = useSelector((state) => state.offerTable.developers || []);
  // const Sprints = useSelector((state) => state.offerTable.OTAddCriteriaKeysArray);
  useEffect(() => {
  if (showDevModal) {
    setDevsList([]);
    dispatch(offerTableHandle.getConstantsFun(accessToken, { constantType: "RESURE_DEVELOPERS" }, "RESURE_DEVELOPERS"));
  }
}, [showDevModal, dispatch, accessToken]);

  useEffect(() => {
    if (developersFromStore.length > 0) {
      setDevsList(
        developersFromStore.map((dev) => ({
          id: dev.id || dev._id,
          name: dev.name || [dev.firstName, dev.lastName].filter(Boolean).join(" "),
        }))
      );
    }
    setShowDevModal(false);
  }, [developersFromStore]);

  const displayAssigneeModal = (record) => {
    setSelectedBugId(record.idTitleSearch._id);
    setSelectedAssignees([]);
    const currentAssignees = record.assignedDevelopers?.map((dev) => dev.id) || [];
    setSelectedAssignees(currentAssignees);
    setShowAssigneeModal(true);
    setDevsList([]);
    setShowDevModal(true);
  };
  const handleAssigneeCancel = () => {
    setShowAssigneeModal(false);
    setSelectedBugId(null);
    setSelectedAssignees([]);
    setShowDevModal(false);
    setDevsList([]);
    setCustomDev("");
  };

  // const handleAddCustomDev = () => {
  //   const trimmed = customDev.trim();
  //   if (!trimmed) {
  //     message.warning("Developer name cannot be empty!");
  //     return;
  //   }
  //   const capitalized = capitalizeFirst(trimmed);
  //   const duplicate = devsList.some((dev) => dev.name.toLowerCase() === capitalized.toLowerCase());
  //   if (duplicate) {
  //     message.warning("This developer already exists!");
  //     return;
  //   }
  //   const newDev = {
  //     id: `custom_${Date.now()}`,
  //     name: capitalized,
  //   };
  //   setDevsList((prevList) => [...prevList, newDev]);
  //   const currentAssignedIds = assignedDevsMap[selectedBugId] || [];
  //   setAssignedDevsMap((prev) => ({
  //     ...prev,
  //     [selectedBugId]: [...currentAssignedIds, newDev.id],
  //   }));
  //   setCustomDev("");
  //   message.success(`${capitalized} added and assigned successfully!`);
  //   inputRef.current?.focus();
  // };

  const handleAssigneeOk = () => {
    if (selectedAssignees.length === 0) {
      message.error("Please select at least one developer!");
      return;
    }
    dispatch(bugReportHandle.updateBugAssignees(selectedBugId, selectedAssignees));
    setShowAssigneeModal(false);
    setSelectedBugId(null);
    setSelectedAssignees([]);
  };

  const handleDevSelection = (selectedIds) => {
    setSelectedAssignees(selectedIds);
  };

const getFilter = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <div style={{ marginBottom: "10px" }}>
        <Select
          mode={dataIndex === "assignedDevelopers" ? "multiple" : "single"} // Only multiple for developers
          style={{ width: "100%" }}
          placeholder={dataIndex === "assignedDevelopers" ? "Select Developer" : "Select Work Type"}
          onFocus={() => {
            if (dataIndex === "assignedDevelopers") {
              setShowDevModal(true);
            }
          }}
          onChange={(value) => {
            if (dataIndex === "assignedDevelopers") {
              setSelectedKeys(value || []); // Array for developers
            } else {
              setSelectedKeys(value ? [value] : []); // Single value wrapped in array for consistency
            }
          }}
          value={
            dataIndex === "assignedDevelopers" 
              ? selectedKeys // Array for developers
              : selectedKeys[0] // Single value for workType
          }
          notFoundContent={showDevModal ? <Spin size="medium" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} /> : "No data"}
          options={
            dataIndex === "assignedDevelopers"
              ? devsList.map((dev) => ({
                  value: dev.id,
                  label: dev.name,
                }))
              : workTypesList.map((workType) => ({
                  value: workType.name,
                  label: workType.name,
                }))
          }
        />
      </div>
      <Space>
        <Button
          type="primary"
          onClick={() => {
            if (dataIndex === "assignedDevelopers") {
              setFilterBydevelopers(selectedKeys); // Array for developers
            } else if (dataIndex === "assignedWorkType") {
              setFilterByworkType(selectedKeys[0] || ""); // Single string value for workType
            }
            setdisableBtn(false);
          }}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Filter
        </Button>
        {/* <Button
          onClick={() => {
            handleReset(clearFilters, setSelectedKeys);
            setdisableBtn(true);
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button> */}
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <FilterFilled style={{ color: filtered ? "#1890FF" : undefined }} />
  ),
});



  // Sprint Modal functions
  const displaySprintModal = (record) => {
    setSelectedBugId(record.idTitleSearch._id);
    setSelectedSprint(record.assignedSprint || null); 
    setShowSprintModal(true);
  };
  const handleSprintCancel = () => {
    setShowSprintModal(false);
    setSelectedBugId(null);
    setSelectedSprint(null);
  };
  const handleSprintOk = () => {
    if (!selectedSprint) {
      message.error("Please select a sprint!");
      return;
    }
    dispatch(bugReportHandle.updateBugSprint(selectedBugId, selectedSprint));
    setShowSprintModal(false);
    setSelectedBugId(null);
    setSelectedSprint(null);
  };

  const handleSprintSelection = (sprintName) => {
    setSelectedSprint(sprintName);
  };
  // const getSprintForBug = (bugId) => {
  //   const sprintId = selectedSprint[bugId];
  //   return sprintList.find((sprint) => sprint.id === sprintId);
  // };

  const handleAddCustomSprint = () => {
    const trimmed = customSprint.trim();
    if (!trimmed) {
      message.warning("Sprint name cannot be empty!");
      return;
    }
    const capitalized = capitalizeFirst(trimmed);
    const duplicate = sprintList.some((sprint) => sprint.name.toLowerCase() === capitalized.toLowerCase());
    if (duplicate) {
      message.warning("This sprint already exists!");
      return;
    }
    const newSprint = {
      id: `custom_${Date.now()}`,
      name: capitalized,
    };
    setSprintList((prevList) => [...prevList, newSprint]);
    setSelectedSprint(capitalized);
    setCustomSprint("");
    message.success(`${capitalized} sprint added successfully!`);
    inputRef.current?.focus();
  };

  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [selectedWorkType, setSelectedWorkType] = useState(null);

  // demo: update local table data (replace with API call in real app)
  // const submitAssignee = () => {
  //   if (!assigneeValue) return;
  //   const picked = userOptions.find(u => u._id === assigneeValue);
  //   setTableData(prev => prev.map(row =>
  //     row._id === assigneeRow._id ? { ...row, assigneeTo: picked } : row
  //   ));
  //   closeAssignee();
  // };

useEffect(() => {
  console.log(filterBydevelopers, filterByworkType);
  let query = {
    ...currentQuery,
    ...(globalSearch.trim()?.length ? { search: globalSearch.trim() } : {}),
    ...(filterBydevelopers.length > 0 ? { developers: JSON.stringify(filterBydevelopers) } : {}),
    ...(filterByworkType ? { workType: filterByworkType } : {}),
    page: currentPage,
    limit: 20,
  };
  dispatch(bugReportHandle.getBugListingDataWith(query));
  setsearchText("");
}, [dispatch, searchText, filterByworkType, filterBydevelopers, currentPage, currentQuery]); 


  let handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    searchRef.current = true;
    setsearchText(selectedKeys[0]);
    let query = {
      ...currentQuery,
      [dataIndex]: selectedKeys[0],
      page: 1,
      limit: 20,
    };
    dispatch(bugReportHandle.getBugListingDataWith(query));
    setsearchedColumn(dataIndex);
    setCurrentQuery(query);
    setCurrentPage(1);
    searchRef.current = false;
  };
  let getstatus = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <div style={{ marginBottom: "10px" }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select Status"
            onChange={(role, event) => {
              setFilterbystatus(role);
            }}
            options={[
              {
                value: "ACTIVE",
                label: "ACTIVE",
              },
              {
                value: "CLOSED",
                label: "CLOSED",
              },
            ]}
          />
        </div>
        <Space>
          <Button
            type="primary"
            onClick={() => {
              handleFilterChange(filterbystatus);
              setdisableBtn(false);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Filter
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters, setSelectedKeys);
              setdisableBtn(true);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? "#1890FF" : undefined }} />,
    render: (text) => (searchedColumn === dataIndex ? <Highlighter highlightStyle={{ backgroundColor: "#FFC069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={text ? text.toString() : ""} /> : text),
  });
  const handleFilterChange = (value) => {
    searchRef.current = true;
    let query = {
      ...currentQuery,
      filterByStatus: value,
    };

    // dispatch(bugReportHandle.getBugListingDataWith(query));
    setCurrentQuery(query);

    setCurrentPage(1);
    searchRef.current = false;
  };
  const handleReset = () => {
    setFilterBydevelopers([])
    setFilterByworkType(null)
    setsearchText("");
    
  };


  const [showComment, setshowComment] = useState(false);
  const { bugReportCommentData, bugReportCommentLoading } = useSelector((state) => state.bugReport);
  const [bugId, setBugId] = useState("");
  const [comment, setComment] = useState("");
  const handleCancelComment = () => {
    setshowComment(false);
  };
  const handleOpenComment = (id) => {
    setBugId(id);
    setshowComment(true);
    dispatch(bugReportHandle.getBugReportComment(id));
  };
  const handlecomment = (e) => {
    setComment(e.target.value);
  };
  const handleAddComment = (id, comment) => {
    dispatch(bugReportHandle.addCommentOnBugs(id, comment));
    setComment(" ");
  };

  function copyText(tetx) {
    return <Typography.Text copyable>{text}</Typography.Text>;
  }

  let getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput.current = node;
          }}
          placeholder={dataIndex === "idTitleSearch" ? `Search in id & title` : dataIndex === "nameEmailSearch" ? `Search in name & email` : "Search in comments"}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => {
            searchRef.current = true;
            handleSearch(selectedKeys, confirm, dataIndex);
            setdisableBtn(false);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              searchRef.current = true;
              handleSearch(selectedKeys, confirm, dataIndex);
              setdisableBtn(false);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters, setSelectedKeys);
              setdisableBtn(true);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,

    render: (text) => {
      const fullName = text.fullName ? text.fullName.toString() : "";
      const email = text.email ? text.email.toString() : "";
      const id = text.id ? text.id : "";
      const title = text.title ? text.title : "";
      const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
      };

      const textToHighlight = text?.content?.map((el) => el?.description).join("\n");
      const strippedText = stripHtmlTags(textToHighlight);
      const content2 = text;
      return searchedColumn === dataIndex ? (
        <>
          {dataIndex === "nameEmailSearch" ? (
            <>
              <div>
                <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={fullName} />
              </div>
              <div style={{ fontSize: "11px", color: "#787474" }}>
                <Typography.Text copyable={{ text: email }}>
                  <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={email} />
                </Typography.Text>
              </div>
            </>
          ) : dataIndex === "idTitleSearch" ? (
            <>
              <div>
                <Typography.Text copyable={{ text: id }}>
                  <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={id} />
                </Typography.Text>
              </div>
              <div style={{ fontSize: "11px", color: "#787474" }}>
                <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={title} />
              </div>
            </>
          ) : dataIndex === "contentSearch" ? (
            <>
              <div>
                <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={strippedText} />
              </div>
            </>
          ) : (
            <>
              <div>
                <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={content2} />
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {dataIndex === "nameEmailSearch" ? (
            <>
              <div style={{ fontWeight: "bold" }}>{text.fullName ? text.fullName : "-"}</div>
              <Typography.Text copyable>{text?.email}</Typography.Text>
            </>
          ) : dataIndex === "idTitleSearch" ? (
            <>
              <Typography.Text copyable>{text?.id}</Typography.Text>
              <div>{text.title ? `${text?.title} ` : ""}</div>
            </>
          ) : dataIndex === "contentSearch" ? (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px", width: "100%", flexDirection: "column" }}>
                <div style={{ width: "100%" }}>
                  {text?.content?.map((el, ind) => (
                    <div style={{ dipslay: "flex", flexDirection: "coloumn" }}>
                      {ind !== 0 && <div style={{ color: "#2976be" }}>{moment(el?.addedDate).format("MMMM D, YYYY hh:mm A")}</div>}
                      {/* <div>{el?.description}</div> */}
                      <div dangerouslySetInnerHTML={{ __html: el?.description }} />
                    </div>
                  ))}
                </div>
                <div style={{ width: "40%", fontSize: "10px" }}>
                  <div style={{ width: "100%" }}>
                    <Button style={{ width: "100px", marginTop: "10px", marginLeft: "90px" }} onClick={() => handleOpenComment(text.id)}>
                      Comments
                    </Button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            text
          )}
        </>
      );
    },
  });

  let handleStatusChange = (data) => {
    searchRef.current = true;
    dispatch(bugReportHandle.statusChange(data.idTitleSearch.id, data.status === "ACTIVE" ? "CLOSED" : "ACTIVE"));
    searchRef.current = false;
  };

  const handleDelete = (record) => {
    dispatch(bugReportHandle.bugPostDelete(record.idTitleSearch.id));
  };

  const columns = [
    {
      title: "Bug Id & title",
      width: "30%",
      key: "idTitleSearch",
      dataIndex: "idTitleSearch",
      ...getColumnSearchProps("idTitleSearch"),
    },
    {
      title: "Created By",
      width: "30%",
      key: "nameEmailSearch",
      align: "center",
      dataIndex: "nameEmailSearch",
      ...getColumnSearchProps("nameEmailSearch"),
    },

    {
      title: "Bug Content",
      width: "50%",
      key: "contentSearch",
      align: "center",
      dataIndex: "contentSearch",
      ...getColumnSearchProps("contentSearch"),
    },
    // add to columns array

    {
      title: "Assignee",
      width: "30%",
      key: "assignee",
      align: "center",
      ...getFilter("assignedDevelopers"),
      render: (_, record) => {
        const tagColors = ["#ff9800", "#2196f3", "#8bc34a", "#e91e63", "#9c27b0", "#0004d4ff"];
        return (
          <div>
            <div
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 10,
              }}
            >
              <PlusCircleFilled onClick={() => displayAssigneeModal(record)} style={{ color: "#275291", fontSize: 16, cursor: "pointer" }} />
            </div>
            <Card
              style={{
                width: "100%", // make sure card width is responsive
                maxWidth: 160,
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                padding: 12,
                boxSizing: "border-box",
              }}
              bodyStyle={{ padding: "8px 12px 28px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 4,
                  flexWrap: "wrap",
                  minWidth: 0, // important for flex shrink to work
                }}
              >
                {record.assignedDevelopers && record.assignedDevelopers.length > 0 ? (
                  record.assignedDevelopers.map((dev, idx) => {
                    const color = tagColors[idx % tagColors.length];
                    return (
                      <Tag
                        key={dev.id || idx}
                        style={{
                          color,
                          padding: "2px 8px",
                          borderRadius: 5,
                          fontSize: 14,
                          whiteSpace: "nowrap",
                          maxWidth: "120px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginBottom: 2,
                        }}
                        title={dev.firstName}
                      >
                        {dev.firstName}
                      </Tag>
                    );
                  })
                ) : (
                  <span style={{ color: "#999" }}>Not assigned</span>
                )}
              </div>
            </Card>
          </div>
        );
      },
    },
    {
      title: "Sprint",
      width: "30%",
      key: "sprint",
      align: "center",
      render: (_, record) => {
        return (
          <div style={{ width: "100%", maxWidth: 160 }}>
            <div
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 10,
              }}
            >
              <EditOutlined onClick={() => displaySprintModal(record)} style={{ color: "#275291", fontSize: 16, cursor: "pointer" }} />
            </div>
            {record.assignedSprint ? (
              <Tag color="blue" style={{ padding: "4px 8px", fontSize: "12px" }}>
                {record.assignedSprint}
              </Tag>
            ) : (
              <div style={{ color: "#999", marginBottom: 4 }}>No sprint</div>
            )}
          </div>
        );
      },
    },
    {
      title: "Work Type",
      width: "20%",
      key: "workType",
      align: "center",
      ...getFilter("assignedWorkType"),
      render: (_, record) => {
        return (
          <div style={{ width: "100%", maxWidth: 170 }}>
            <div
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 10,
              }}
            >
              <EditOutlined onClick={() => displayWorkTypeModal(record)} style={{ color: "#275291", fontSize: 16, cursor: "pointer" }} />
            </div>
            <div
              style={{
                minHeight: 40,
                marginBottom: 8,
                marginTop: 16,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 4,
                overflowWrap: "break-word",
                minWidth: 0,
              }}
            >
              {record.assignedWorkType ? <Tag style={{ padding: "4px 8px" }}>{record.assignedWorkType}</Tag> : <span style={{ color: "#999", paddingLeft: 10 }}>Not assigned</span>}
            </div>
          </div>
        );
      },
    },
    {
      title: "Date",
      width: "20%",
      align: "center",
      key: "date",
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
      render: (_, record) => {
        return <Text> {moment(record.createdAt).format("MMMM D, YYYY hh:mm A")}</Text>;
      },
    },
    {
      title: "Images",
      width: "15%",
      align: "center",
      key: "email",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              cursor: "pointer",
            }}
            // onClick={() => pdfDownload(record.pdfUrl)}
          >
            {record && record?.imageUrls?.length > 0 ? (
              record &&
              record?.imageUrls &&
              record &&
              record?.imageUrls?.map((ele) => {
                return <Image width={70} alt="logo" src={ele} />;
              })
            ) : (
              <text>N/A</text>
            )}

            <Text style={{ color: "#5a5ad2" }}>{record.pdfFileName}</Text>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "",
      width: "25%",
      align: "center",
      ...getstatus("isActive"),
      // filters: [
      //   { text: "ACTIVE", value: "ACTIVE" },
      //   { text: "CLOSED", value: "CLOSED" },
      // ],
      // ...handleFilterChange(),
      // onFilter:handleFilterChange, // Call the function when filter changes

      key: "x",
      render: (_, record) => (
        <Popconfirm placement="top" title={"Are you sure,you want to change the status?"} onConfirm={() => handleStatusChange(record)} okText="Yes" cancelText="No">
          <Button size="small" style={{ color: record.status === "ACTIVE" ? "green" : "red" }}>
            {record.status}
          </Button>
        </Popconfirm>
      ),
    },
  ];

  const deleteBugsColumn = {
    title: "Delete",
    width: "13%",
    key: "jira",
    render: (_, record) => {
      return (
        <Popconfirm placement="top" title={"Are you sure to delete this bug?"} onConfirm={() => handleDelete(record)} okText="Yes" cancelText="No">
          <DeleteOutlined style={{ color: "red", paddingLeft: 20, cursor: "pointer" }} />
        </Popconfirm>
      );
    },
  };

  if (roleAccessFunc(roleAccessed, "DELETE_BUGS_TICKET")) {
    columns.splice(6, 0, deleteBugsColumn);
  }

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Input.Search placeholder="Search" allowClear enterButton={<SearchOutlined />} value={globalSearch} onChange={(e) => setGlobalSearch(e.target.value)} onSearch={handleGlobalSearch} style={{ width: "100%", maxWidth: 500, marginLeft: 500,marginTop: -15, display: "block" }} size="middle" />
        {/* <FilterOutlined
          style={{
            fontSize: "22px",
            cursor: "pointer",
            marginTop: "4px",
            marginLeft: 8,
          }}
          onClick={openFilterModal}
        /> */}
        <Button
          disabled={disableBtn}
          onClick={() => {
            handleReset();
            setdisableBtn(true);
          }}
          size="small"
          style={{ marginLeft: 8,marginTop: -15 }}
        >
          Reset Filters
        </Button>
        {/* {!disableBtn && <FilterDisplay filterOptions={currentQuery} origin="bugsTable" />} */}
      </div>
      {/* <Modal
        title="FILTER"
        visible={showFilterModal}
        onCancel={closeFilterModal}
        footer={[
          <Button
            key="clear"
            onClick={() =>
              setFilterValues({
                assignee: [],
                sprint: [],
                workType: [],
                status: "",
                startDate: null,
                endDate: null,
              })
            }
            style={{ marginRight: 8 }}
          >
            Clear All
          </Button>,
          <Button key="cancel" onClick={closeFilterModal} style={{ marginRight: 8 }}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={() => handleApplyFilter()}>
            Apply
          </Button>,
        ]}
        bodyStyle={{
          padding: "24px 32px",
          background: "#fafbfc",
          borderRadius: 8,
        }}
      >
        <Form layout="vertical" style={{ marginBottom: 0 }}>
          <Row gutter={24}>
            <Col span={4}>
              <Form.Item label="Status" style={{ marginBottom: 0 }}>
                <Select value={filterValues.status} onChange={(value) => setFilterValues((v) => ({ ...v, status: value }))} allowClear style={{ width: "100%" }}>
                  <Select.Option value="ACTIVE">Active</Select.Option>
                  <Select.Option value="CLOSED">Closed</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Assignee" style={{ marginBottom: 0 }}>
                <Select
                  mode="multiple"
                  value={filterValues.assignee}
                  onChange={(value) => setFilterValues((v) => ({ ...v, assignee: value }))}
                  options={devsList.map((dev) => ({
                    value: dev.id,
                    label: dev.name,
                  }))}
                  allowClear
                  placeholder="Select Assignee"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Sprint" style={{ marginBottom: 0 }}>
                <Select
                  mode="multiple"
                  value={filterValues.sprint}
                  onChange={(value) => setFilterValues((v) => ({ ...v, sprint: value }))}
                  options={sprintList.map((sprint) => ({
                    value: sprint.id,
                    label: sprint.name,
                  }))}
                  allowClear
                  placeholder="Select Sprint"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Work Type" style={{ marginBottom: 0 }}>
                <Select
                  mode="multiple"
                  value={filterValues.workType}
                  onChange={(value) => setFilterValues((v) => ({ ...v, workType: value }))}
                  options={workTypesList.map((wt) => ({
                    value: wt.id,
                    label: `${wt.icon} ${wt.name}`,
                  }))}
                  allowClear
                  placeholder="Select Work Type"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal> */}
      {/* Work Type Modal */}
      <Modal title="Assign Work Type" visible={showWorkTypeModal} onOk={handleWorkTypeOk} onCancel={handleWorkTypeCancel} width={600}>
        <div style={{ marginBottom: 16 }}>
          <Select style={{ width: "100%" }} placeholder="Select work type" value={selectedWorkType} onChange={handleWorkTypeSelection}>
            {workTypesList.map((workType) => (
              <Select.Option key={workType.id} value={workType.name}>
                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span>{workType.name}</span>
                </span>
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
      <Modal title="Assign Developer" visible={showAssigneeModal} onOk={handleAssigneeOk} onCancel={handleAssigneeCancel} width={600}>
        <div style={{ marginBottom: 16 }}>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select developers"
            // value={selectedAssignees}
            onChange={handleDevSelection}
            onDropdownVisibleChange={(open) => {
              // setIsAssigneeDropdownOpen(open);
              if (open) {
                setShowDevModal(true);
              } else {
                setShowDevModal(false);
                setDevsList([]); 
              }
            }}
            key={selectedBugId}
            notFoundContent={showDevModal ? <Spin size="medium" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} /> : "No data"}
            dropdownRender={(menu) => (
              <>
                {menu}
                {/* <div
                  style={{
                    padding: "8px",
                    borderTop: "1px solid #d9d9d9",
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <Input ref={inputRef} placeholder="Add custom developer" value={customDev} onChange={(e) => setCustomDev(e.target.value)} onPressEnter={handleAddCustomDev} style={{ flex: 1 }} />
                  <Button type="primary" onClick={handleAddCustomDev} disabled={!customDev.trim()}>
                    Add
                  </Button>
                </div> */}
              </>
            )}
          >
            {devsList.map((dev) => (
              <Select.Option key={dev.id} value={dev.id}>
                {dev.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
      {/* Sprint Modal */}
      <Modal title="Assign Sprint" visible={showSprintModal} onOk={handleSprintOk} onCancel={handleSprintCancel} width={600}>
        <div style={{ marginBottom: 16 }}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select sprint"
            value={selectedSprint}
            onChange={handleSprintSelection}
            dropdownRender={(menu) => (
              <>
                {menu}
                <div
                  style={{
                    padding: "8px",
                    borderTop: "1px solid #d9d9d9",
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <Input placeholder="Add custom sprint" value={customSprint} onChange={(e) => setCustomSprint(e.target.value)} onPressEnter={handleAddCustomSprint} style={{ flex: 1 }} />
                  <Button type="primary" onClick={handleAddCustomSprint} disabled={!customSprint.trim()}>
                    Add
                  </Button>
                </div>
              </>
            )}
          >
            {sprintList.map((sprint) => (
              <Select.Option key={sprint.id} value={sprint.name}>
                {sprint.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
      <Modal title="Bug Comment" visible={showComment} onCancel={handleCancelComment} footer={false}>
        <div style={{ display: "flex" }}>
          {" "}
          <Input value={comment} name={comment} placeholder="Enter your comment here..." onChange={(e) => handlecomment(e)} />
          <Button onClick={() => handleAddComment(bugId, comment)}>Add Comments</Button>
        </div>
        {bugReportCommentLoading ? (
          <Loading />
        ) : (
          <>
            {bugReportCommentData?.length ? (
              bugReportCommentLoading ? (
                <Loading />
              ) : (
                <List
                  bordered={true}
                  style={{ maxHeight: "calc(6* 80px)", overflow: "auto" }}
                  itemLayout="horizontal"
                  dataSource={bugReportCommentData}
                  renderItem={(item) => {
                    const intials = generateInitialsFromObj(item);
                    return (
                      <List.Item key={item._id}>
                        <List.Item.Meta
                          avatar={
                            item?.createdBy?.profileImg && item?.createdBy?.profileImg?.original ? (
                              <Avatar
                                style={{
                                  border: "3px solid #085191",
                                  background: "#347FC0",
                                }}
                                size={35}
                                src={item?.createdBy?.profileImg.original}
                              />
                            ) : intials ? (
                              <Avatar size={35} style={{ background: "#085191" }}>
                                {intials}
                              </Avatar>
                            ) : (
                              <Avatar size={35} icon={<UserOutlined />} style={{ background: "#085191" }} />
                            )
                          }
                          title={<span style={{ fontSize: "20px" }}>{generateFullNameFromObj(item)}</span>}
                          description={<text>{item?.comment}</text>}
                        />
                      </List.Item>
                    );
                  }}
                />
              )
            ) : (
              <EmptyData />
            )}
          </>
        )}
      </Modal>
      {/* {jiraModal ? (
        <Modal
          title="Enter Bug Details To export on JIRA portal"
          visible={jiraModal}
          onCancel={canCleJIRAmodal}
          footer={false}
        >
          <JIRAModal
            handleCancel={canCleJIRAmodal}
            selectedJIRA={selectedJIRA}
          />
        </Modal>
      ) : null} */}
      <Form form={form} component={false}>
        {bugLlistLoading ? (
          <Loading />
        ) : (
          <>
            <Table
              rowKey={(record) => record._id}
              bordered
              dataSource={bugLlistingData}
              scroll={{ y: "70vh" }}
              maxHeight={"100vh"}
              columns={columns}
              rowClassName="editable-row"
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: false,
                pageSize: 20,
                current: currentPage,
                total: totalRecords,
                onChange: (page) => {
                  if (!searchRef.current) {
                    let query = {
                      ...currentQuery,
                      page,
                      limit: 20,
                    };
                    dispatch(bugReportHandle.getBugListingDataWith(query));
                    setCurrentPage(page);
                  }
                },
              }}
            />
          </>
        )}
      </Form>
    </>
  );
};

export { BUGTable };
